import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../../service/local-storage.service';
import { ActivatedRoute } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';

@Component({
  selector: 'app-event-donor-menulist',
  templateUrl: './event-donor-menulist.component.html',
  styleUrl: './event-donor-menulist.component.scss'
})
export class EventDonorMenulistComponent implements OnInit{
  getEventDonorListMain: any;
  getEventDonorList: any;
  subEventId: any;
  userTypeId: any;

  constructor(
    private mainService: MainService,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    public dialog: MatDialog
  ) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
    });
  }

  ngOnInit(): void {
    this.getSubEventDonorData();
  }

  getSubEventDonorData() {
    this.mainService.getApi(ApiUrls.getSubEventDonorList + this.subEventId).subscribe(res => {
      if (this.userTypeId == 1) {
        this.getEventDonorListMain = res.sub_event_donor;
        this.getEventDonorList = res.sub_event_donor;
      } else {
        this.getEventDonorListMain = res.sub_event_donor.filter((x: any) => x.is_active == 1);
        this.getEventDonorList = res.sub_event_donor.filter((x: any) => x.is_active == 1);
      }
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getEventDonorList = this.getEventDonorListMain
      return;
    }
    this.getEventDonorList = this.getEventDonorListMain.filter((user: any) => {
      return user.member_name.toLowerCase().includes(filterValue)
    });
  }

}
